import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {JhiEventManager} from 'ng-jhipster';
import {Subscription} from 'rxjs';
import {IVaiTro} from '@entities/vai-tro/vai-tro.model';
import {IDashboardType} from '@app/home/dashboard-type/dashboard-type';
import {DonViUser, IDonViUser} from '@entities/don-vi/don-vi.model';
import {DonViService} from '@entities/don-vi/don-vi.service';
import {VaiTro} from '@entities/vai-tro/vai-tro.model';

@Component({
  selector: 'app-don-vi-detail',
  templateUrl: './don-vi-detail.component.html',
  styleUrls: ['./don-vi-detail.component.scss'],
})
export class DonViDetailComponent implements OnInit, OnDestroy {
  donVi: IDonViUser;
  donViId: any;
  eventSubscriber: Subscription;
  selectedRole: IVaiTro;
  dashboardTypes: IDashboardType[];

  constructor(
    private eventManager: JhiEventManager,
    private activatedRoute: ActivatedRoute,
    private service: DonViService,
  ) {
    this.donVi = new DonViUser();
    this.selectedRole = new VaiTro();
    this.dashboardTypes = [];
  }

  ngOnInit() {
    this.donViId = this.activatedRoute.snapshot.paramMap.get('donVi');
    this.activatedRoute.data.subscribe((data: any) => {
      const {
        donVi,
        dashboardTypes,
      }: {
        donVi: IDonViUser;
        dashboardTypes: IDashboardType[];
      } = data;
      this.donVi = donVi;
      if (dashboardTypes) {
        this.dashboardTypes = dashboardTypes;
        this.donVi.tbDashboardType = dashboardTypes.find(
          (i) => i.id === this.donVi.tbDashboardTypeId,
        );
      }
    });
    this.eventSubscriber = this.eventManager.subscribe(
      'donViModification',
      (eventContent) => this.getDetail(eventContent),
    );
  }

  getDetail(eventContent?: any) {
    this.service.find(this.donViId).subscribe((res) => {
      const body: any = res.body || {};
      this.donVi = new DonViUser().assign(body) as IDonViUser;
      this.donVi.tbDashboardType = this.dashboardTypes.find(
        (i) => i.id === this.donVi.tbDashboardTypeId,
      );
    });
  }

  ngOnDestroy() {
    // this.eventManager.destroy(this.eventSubscriber);
  }

  selectRole(item: IVaiTro) {
    this.selectedRole = {...item};
  }
}
